import { addLocale } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { forwardRef } from "react";

addLocale('pt-BR', {
  firstDayOfWeek: 0,
  dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  today: 'Hoje',
  clear: 'Limpar',
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sem',
});

export const CalendarField = forwardRef((props, fowardedRef) => {
  return (
    <Calendar
      ref={fowardedRef}
      id="time24"
      className="w-full"
      dateFormat="dd/mm/yy"
      hourFormat="24"
      showTime
      locale="pt-BR"
      hideOnDateTimeSelect
      {...props}
    />
  )
})